import { render, staticRenderFns } from "./CustomerKlaviyo.vue?vue&type=template&id=a2dccca0"
import script from "./CustomerKlaviyo.vue?vue&type=script&lang=js"
export * from "./CustomerKlaviyo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports